import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
// Pack browsing has moved to the marketing site — the in-app gallery is retired.
// import SoundPacksGallery from './SoundPacksGallery';
import AdminPage from './AdminPage';
import ReorderSounds from './admin/ReorderSounds';
import UserProfile from './UserProfile';
import SubscribePage from './SubscribePage';
import BuyPackPage from './BuyPackPage';
import AddToCartPage from './AddToCartPage';
import PurchaseSuccessPage from './PurchaseSuccessPage';
import DownloadStartedPage from './DownloadStartedPage';
import CartPage from './CartPage';
import PageShell from './layout/PageShell';

// Wraps the app screens in the site shell (SiteHeader + centred column).
function ShellLayout() {
    return (
        <PageShell variant="full">
            <Outlet />
        </PageShell>
    );
}

function AuthenticatedApp() {
    return (
        <Router>
            <Routes>
                {/* Redirect interstitial — no site nav, so it doesn't flash the
                    header buttons before Stripe takes over. */}
                <Route path="/buy/:packId" element={<BuyPackPage />} />
                {/* Same shape as /buy/:packId — adds the pack to the cart, then /cart. */}
                <Route path="/cart/add/:packId" element={<AddToCartPage />} />
                {/* Stripe success landing — no site nav, same as the buy interstitial. */}
                <Route path="/purchase-success" element={<PurchaseSuccessPage />} />
                {/* Where the Account page's plugin-download buttons send the user
                    (?platform=mac|windows) — same shape as the interstitials above. */}
                <Route path="/download-started" element={<DownloadStartedPage />} />
                <Route element={<ShellLayout />}>
                    <Route path="/" element={<Navigate to="/account" replace />} />
                    {/* Retired — pack browsing now lives on the marketing site.
                    <Route path="/packsGallery" element={<SoundPacksGallery />} /> */}
                    <Route path="/account" element={<UserProfile />} />
                    <Route path="/subscribe" element={<SubscribePage />} />
                    <Route path="/cart" element={<CartPage />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/admin/reorder-sounds/:packId" element={<ReorderSounds />} />
                    {/* Anything unmatched (old /packsGallery links included) → account. */}
                    <Route path="*" element={<Navigate to="/account" replace />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default AuthenticatedApp;